import { gsap } from 'gsap';

// Port of src/app/animations/expandFadeInAnimation.ts (Angular trigger 'expandFadeIn').
//
// Angular spec: void state = { opacity: 0, height: 0, overflow: hidden },
// '*' state = { opacity: 1, height: auto, overflow: hidden },
// transition void <=> * over 75ms ease-in-out.
//
// Ported as GSAP functions (instead of CSS keyframes) because CSS cannot
// animate height to/from 'auto'; GSAP can. 'power1.inOut' is GSAP's
// equivalent of CSS ease-in-out. Overflow stays hidden during and after the
// animation, exactly like the Angular states.

const DURATION_S = 0.075; // 75ms

/** :enter — grow from height 0 / opacity 0 to natural height / opacity 1. */
export function expandFadeInEnter(element: HTMLElement): gsap.core.Tween {
  element.style.overflow = 'hidden';
  return gsap.from(element, {
    height: 0,
    opacity: 0,
    duration: DURATION_S,
    ease: 'power1.inOut',
    onComplete: () => {
      // Match the Angular '*' state: natural height, overflow stays hidden.
      gsap.set(element, { clearProps: 'height,opacity' });
    }
  });
}

/**
 * :leave — collapse to height 0 / opacity 0, then call onComplete (where the
 * caller should unmount the element, mirroring Angular's removal after :leave).
 */
export function expandFadeInLeave(element: HTMLElement, onComplete?: () => void): gsap.core.Tween {
  element.style.overflow = 'hidden';
  return gsap.to(element, {
    height: 0,
    opacity: 0,
    duration: DURATION_S,
    ease: 'power1.inOut',
    overwrite: true,
    onComplete
  });
}
